import * as Cesium from 'cesium';

export const ACCENT = new Cesium.Color(204 / 255, 245 / 255, 78 / 255, 1.0);
export const ACCENT_FILL = new Cesium.Color(204 / 255, 245 / 255, 78 / 255, 0.10);
export const BLACK = Cesium.Color.BLACK;
export const PREVIEW_COLOR = new Cesium.Color(0.5, 0.85, 1.0, 0.9);

export const MAPBOX_STYLES = {
  dark: 'dark-v10',
  light: 'light-v10',
  streets: 'streets-v11',
  satellite: 'satellite-v9',
  outdoors: 'outdoors-v11',
} as const;

export const SENSOR_BEAM_COLOR = new Cesium.Color(0.2, 0.68, 1.0, 1.0);
export const RECT_SENSOR_BEAM_COLOR = new Cesium.Color(1.0, 0.68, 0.16, 1.0);
export const GS_HOVER_COLOR = new Cesium.Color(1.0, 0.34, 0.06, 1.0);

export const LOS_GS_SATELLITE_COLOR = Cesium.Color.fromCssColorString('#BB86FC');
export const LOS_TARGET_SATELLITE_COLOR = Cesium.Color.fromCssColorString('#FFB000');
export const LOS_SATELLITE_SATELLITE_COLOR = Cesium.Color.fromCssColorString('#00E5FF');

export const CLOSE_SATELLITE_MODEL_URI = '/assets/advanced-composition-explorer.glb';
export const CLOSE_SATELLITE_MODEL_DISTANCE_M = 14_000_000;

export const GS_RING_MAX_RADIUS = 900000;
export const GS_RING_DURATION = 3.0;
export const GS_BIDIRECTIONAL_COLOR = '#3a9f9cff';
export const GS_UNIDIRECTIONAL_COLOR = '#9f6e23ff';

export const previewPoint = {
  pixelSize: 6,
  color: PREVIEW_COLOR,
  outlineColor: BLACK.withAlpha(0.7),
  outlineWidth: 1,
  show: true,
} as const;

export const MU = 398600.4418;
